import {Component, inject, PLATFORM_ID} from '@angular/core';
import {PageHeaderComponent} from "../../common/page/page-header/page-header.component";
import {HomeEventsComponent} from '../../home/home-events/home-events.component';
import {PageFooterComponent} from '../../common/page/page-footer/page-footer.component';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {loadFAQ} from '../../../../common/faq';

@Component({
  selector: 'app-sessions',
  imports: [
    PageHeaderComponent,
    HomeEventsComponent,
    PageFooterComponent
  ],
  templateUrl: './sessions.component.html',
})
export class SessionsComponent {
  platformId = inject(PLATFORM_ID);
  document = inject(DOCUMENT);

  ngAfterViewInit() {

    if (isPlatformBrowser(this.platformId)) {
      loadFAQ(this.document)
    }
  }
}
